import { render } from "./CrudeOil.vue?vue&type=template&id=069331da&ts=true"
import script from "./CrudeOil.vue?vue&type=script&lang=ts"
export * from "./CrudeOil.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Develop\\WorkSpace\\Codebase\\CZone\\EICPartnershipSVN\\UI_EICPartnership\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__